import { __decorate, __metadata } from "tslib";
import { AppRequest } from '@core/shared/app-request';
import { AppRequestMethod } from '@core/shared/request';
import { Expose, Model, ModelId } from '@core/shared/model';
let GetMediaAssetDetailsResponse = /*#__PURE__*/(() => {
  let GetMediaAssetDetailsResponse = class GetMediaAssetDetailsResponse extends Model {};
  __decorate([Expose(), __metadata("design:type", Object)], GetMediaAssetDetailsResponse.prototype, "details", void 0);
  GetMediaAssetDetailsResponse = __decorate([ModelId("GetMediaAssetDetailsResponse") // auto-generated by generate-model-ids
  ], GetMediaAssetDetailsResponse);
  return GetMediaAssetDetailsResponse;
})();
export { GetMediaAssetDetailsResponse };
let GetMediaAssetDetailsRequest = /*#__PURE__*/(() => {
  let GetMediaAssetDetailsRequest = class GetMediaAssetDetailsRequest extends Model {
    static {
      this.Response = GetMediaAssetDetailsResponse;
    }
  };
  __decorate([Expose(), __metadata("design:type", Boolean)], GetMediaAssetDetailsRequest.prototype, "withRawData", void 0);
  __decorate([Expose(), __metadata("design:type", Boolean)], GetMediaAssetDetailsRequest.prototype, "withDerived", void 0);
  __decorate([Expose(), __metadata("design:type", Number)], GetMediaAssetDetailsRequest.prototype, "assetId", void 0);
  GetMediaAssetDetailsRequest = __decorate([AppRequest('media', 'assets/detail', {
    httpMethod: AppRequestMethod.POST
  }), ModelId("GetMediaAssetDetailsRequest") // auto-generated by generate-model-ids
  ], GetMediaAssetDetailsRequest);
  return GetMediaAssetDetailsRequest;
})();
export { GetMediaAssetDetailsRequest };
let GetMediaAssetDetailsByUrlRequest = /*#__PURE__*/(() => {
  let GetMediaAssetDetailsByUrlRequest = class GetMediaAssetDetailsByUrlRequest extends Model {
    static {
      this.Response = GetMediaAssetDetailsResponse;
    }
  };
  __decorate([Expose(), __metadata("design:type", Boolean)], GetMediaAssetDetailsByUrlRequest.prototype, "withRawData", void 0);
  __decorate([Expose(), __metadata("design:type", Boolean)], GetMediaAssetDetailsByUrlRequest.prototype, "withDerived", void 0);
  __decorate([Expose(), __metadata("design:type", String)], GetMediaAssetDetailsByUrlRequest.prototype, "provider", void 0);
  __decorate([Expose(), __metadata("design:type", String)], GetMediaAssetDetailsByUrlRequest.prototype, "url", void 0);
  GetMediaAssetDetailsByUrlRequest = __decorate([AppRequest('media', 'assets/detail-by-url', {
    httpMethod: AppRequestMethod.POST
  }), ModelId("GetMediaAssetDetailsByUrlRequest") // auto-generated by generate-model-ids
  ], GetMediaAssetDetailsByUrlRequest);
  return GetMediaAssetDetailsByUrlRequest;
})();
export { GetMediaAssetDetailsByUrlRequest };